/******/ (() => {
  // webpackBootstrap
  /******/ 'use strict';
  /******/ var __webpack_modules__ = {
    /***/ './resources/app.ts':
      /*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var _scripts_components_Geolocator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/Geolocator */ './resources/scripts/components/Geolocator.ts');
        /* harmony import */ var _scripts_components_InventoryDeliveryComponent_InventoryDeliveryComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          /*! ./scripts/components/InventoryDeliveryComponent/InventoryDeliveryComponent */ './resources/scripts/components/InventoryDeliveryComponent/InventoryDeliveryComponent.ts'
        );
        /* harmony import */ var _scripts_components_ScrollToggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/ScrollToggle */ './resources/scripts/components/ScrollToggle.ts');
        /* harmony import */ var _scripts_components_ThumbnailDots_ThumbnailDots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/ThumbnailDots/ThumbnailDots */ './resources/scripts/components/ThumbnailDots/ThumbnailDots.ts');
        /* harmony import */ var _scripts_components_CookieBanner_CookieBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/CookieBanner/CookieBanner */ './resources/scripts/components/CookieBanner/CookieBanner.ts');
        /* harmony import */ var _scripts_components_ProductUpsell_ProductUpsell__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./scripts/components/ProductUpsell/ProductUpsell */ './resources/scripts/components/ProductUpsell/ProductUpsell.ts');
        /* harmony import */ var _scripts_components_PeekHint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/PeekHint */ './resources/scripts/components/PeekHint.ts');

        var scrollToggle = new _scripts_components_ScrollToggle__WEBPACK_IMPORTED_MODULE_0__['default']();
        scrollToggle.init();
        (0, _scripts_components_PeekHint__WEBPACK_IMPORTED_MODULE_1__['default'])();
        customElements.define('edition-geolocator', _scripts_components_Geolocator__WEBPACK_IMPORTED_MODULE_2__['default']);
        customElements.define('inventory-delivery-component', _scripts_components_InventoryDeliveryComponent_InventoryDeliveryComponent__WEBPACK_IMPORTED_MODULE_3__['default']);
        customElements.define('thumbnail-dots', _scripts_components_ThumbnailDots_ThumbnailDots__WEBPACK_IMPORTED_MODULE_4__['default']);
        customElements.define('cookie-banner', _scripts_components_CookieBanner_CookieBanner__WEBPACK_IMPORTED_MODULE_5__['default']);
        customElements.define('product-upsell', _scripts_components_ProductUpsell_ProductUpsell__WEBPACK_IMPORTED_MODULE_6__['default']);

        /***/
      },

    /***/ './resources/scripts/components/CookieBanner/CookieBanner.ts':
      /*!*******************************************************************!*\
  !*** ./resources/scripts/components/CookieBanner/CookieBanner.ts ***!
  \*******************************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ CookieBanner,
          /* harmony export */
        });
        /* harmony import */ var _utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @utils/Logger */ './resources/scripts/utils/Logger.ts');
        /* harmony import */ var _utils_Storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/Storage */ './resources/scripts/utils/Storage.ts');
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function ownKeys(e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            (r &&
              (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
              })),
              t.push.apply(t, o));
          }
          return t;
        }
        function _objectSpread(e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2
              ? ownKeys(Object(t), !0).forEach(function (r) {
                  _defineProperty(e, r, t[r]);
                })
              : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
                : ownKeys(Object(t)).forEach(function (r) {
                    Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                  });
          }
          return e;
        }
        function _toArray(r) {
          return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest();
        }
        function _nonIterableRest() {
          throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
        }
        function _unsupportedIterableToArray(r, a) {
          if (r) {
            if ('string' == typeof r) return _arrayLikeToArray(r, a);
            var t = {}.toString.call(r).slice(8, -1);
            return ('Object' === t && r.constructor && (t = r.constructor.name), 'Map' === t || 'Set' === t ? Array.from(r) : 'Arguments' === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0);
          }
        }
        function _arrayLikeToArray(r, a) {
          (null == a || a > r.length) && (a = r.length);
          for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
          return n;
        }
        function _iterableToArray(r) {
          if (('undefined' != typeof Symbol && null != r[Symbol.iterator]) || null != r['@@iterator']) return Array.from(r);
        }
        function _arrayWithHoles(r) {
          if (Array.isArray(r)) return r;
        }
        function _regenerator() {
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
            t,
            r = 'function' == typeof Symbol ? Symbol : {},
            n = r.iterator || '@@iterator',
            o = r.toStringTag || '@@toStringTag';
          function i(r, n, o, i) {
            var c = n && n.prototype instanceof Generator ? n : Generator,
              u = Object.create(c.prototype);
            return (
              _regeneratorDefine2(
                u,
                '_invoke',
                (function (r, n, o) {
                  var i,
                    c,
                    u,
                    f = 0,
                    p = o || [],
                    y = !1,
                    G = {
                      p: 0,
                      n: 0,
                      v: e,
                      a: d,
                      f: d.bind(e, 4),
                      d: function d(t, r) {
                        return ((i = t), (c = 0), (u = e), (G.n = r), a);
                      },
                    };
                  function d(r, n) {
                    for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
                      var o,
                        i = p[t],
                        d = G.p,
                        l = i[2];
                      r > 3 ? (o = l === n) && ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]), (i[4] = i[5] = e)) : i[0] <= d && ((o = r < 2 && d < i[1]) ? ((c = 0), (G.v = n), (G.n = i[1])) : d < l && (o = r < 3 || i[0] > n || n > l) && ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                    }
                    if (o || r > 1) return a;
                    throw ((y = !0), n);
                  }
                  return function (o, p, l) {
                    if (f > 1) throw TypeError('Generator is already running');
                    for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y; ) {
                      i || (c ? (c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : (G.n = u)) : (G.v = u));
                      try {
                        if (((f = 2), i)) {
                          if ((c || (o = 'next'), (t = i[o]))) {
                            if (!(t = t.call(i, u))) throw TypeError('iterator result is not an object');
                            if (!t.done) return t;
                            ((u = t.value), c < 2 && (c = 0));
                          } else (1 === c && (t = i['return']) && t.call(i), c < 2 && ((u = TypeError("The iterator does not provide a '" + o + "' method")), (c = 1)));
                          i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                      } catch (t) {
                        ((i = e), (c = 1), (u = t));
                      } finally {
                        f = 1;
                      }
                    }
                    return { value: t, done: y };
                  };
                })(r, o, i),
                !0
              ),
              u
            );
          }
          var a = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          t = Object.getPrototypeOf;
          var c = [][n]
              ? t(t([][n]()))
              : (_regeneratorDefine2((t = {}), n, function () {
                  return this;
                }),
                t),
            u = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c));
          function f(e) {
            return (Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : ((e.__proto__ = GeneratorFunctionPrototype), _regeneratorDefine2(e, o, 'GeneratorFunction')), (e.prototype = Object.create(u)), e);
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            _regeneratorDefine2(u, 'constructor', GeneratorFunctionPrototype),
            _regeneratorDefine2(GeneratorFunctionPrototype, 'constructor', GeneratorFunction),
            (GeneratorFunction.displayName = 'GeneratorFunction'),
            _regeneratorDefine2(GeneratorFunctionPrototype, o, 'GeneratorFunction'),
            _regeneratorDefine2(u),
            _regeneratorDefine2(u, o, 'Generator'),
            _regeneratorDefine2(u, n, function () {
              return this;
            }),
            _regeneratorDefine2(u, 'toString', function () {
              return '[object Generator]';
            }),
            (_regenerator = function _regenerator() {
              return { w: i, m: f };
            })()
          );
        }
        function _regeneratorDefine2(e, r, n, t) {
          var i = Object.defineProperty;
          try {
            i({}, '', {});
          } catch (e) {
            i = 0;
          }
          ((_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
            function o(r, n) {
              _regeneratorDefine2(e, r, function (e) {
                return this._invoke(r, n, e);
              });
            }
            r ? (i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : (e[r] = n)) : (o('next', 0), o('throw', 1), o('return', 2));
          }),
            _regeneratorDefine2(e, r, n, t));
        }
        function asyncGeneratorStep(n, t, e, r, o, a, c) {
          try {
            var i = n[a](c),
              u = i.value;
          } catch (n) {
            return void e(n);
          }
          i.done ? t(u) : Promise.resolve(u).then(r, o);
        }
        function _asyncToGenerator(n) {
          return function () {
            var t = this,
              e = arguments;
            return new Promise(function (r, o) {
              var a = n.apply(t, e);
              function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'next', n);
              }
              function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'throw', n);
              }
              _next(void 0);
            });
          };
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _callSuper(t, o, e) {
          return ((o = _getPrototypeOf(o)), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)));
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
          if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function _inherits(t, e) {
          if ('function' != typeof e && null !== e) throw new TypeError('Super expression must either be null or a function');
          ((t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, 'prototype', { writable: !1 }), e && _setPrototypeOf(t, e));
        }
        function _wrapNativeSuper(t) {
          var r = 'function' == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(t, arguments, _getPrototypeOf(this).constructor);
              }
              return ((Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(Wrapper, t));
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return (r && _setPrototypeOf(p, r.prototype), p);
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
            return !!t;
          })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf('[native code]');
          } catch (n) {
            return 'function' == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return ((t.__proto__ = e), t);
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }

        var CONSENT_STORAGE_KEY = 'cookieSelections';
        var CONSENT_DENIED_DEFAULTS = {
          personalization: false,
          marketing: false,
          analytics: false,
        };
        var CONSENT_KEYS = ['personalization', 'marketing', 'analytics'];
        /**
         * Cookie consent banner web component.
         *
         * Handles Consent Mode v2 (gtag default + update), Shopify Customer Privacy API
         * integration, and a consent-category checkbox UI with synced consent/details tabs.
         *
         * @example
         * ```html
         * <cookie-banner data-force-show="true"></cookie-banner>
         * ```
         *
         * @fires {CustomEvent} edition:consent-default-set - After gtag consent defaults are applied.
         * @fires {CustomEvent} edition:consent-updated     - After the user accepts, selects, or rejects.
         *
         * @see {@link showBanner} to open the banner programmatically.
         */
        var CookieBanner = /*#__PURE__*/ (function (_HTMLElement) {
          function CookieBanner() {
            var _this;
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            _classCallCheck(this, CookieBanner);
            _this = _callSuper(this, CookieBanner, [].concat(args));
            _defineProperty(_this, 'consentApiReady', false);
            /** Sets gtag consent defaults, fires `edition:consent-default-set`, and optionally loads GTM. */
            _defineProperty(
              _this,
              'setupConsent',
              /*#__PURE__*/ _asyncToGenerator(
                /*#__PURE__*/ _regenerator().m(function _callee() {
                  var _local$get, _window$gtag, _window, _window$gtag2, _window2, _window$gtag3, _window3;
                  var selections;
                  return _regenerator().w(function (_context) {
                    while (1)
                      switch (_context.n) {
                        case 0:
                          _this.ensureGtag();
                          selections = (_local$get = _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY)) !== null && _local$get !== void 0 ? _local$get : CONSENT_DENIED_DEFAULTS;
                          (_window$gtag = (_window = window).gtag) === null ||
                            _window$gtag === void 0 ||
                            _window$gtag.call(_window, 'consent', 'default', {
                              functionality_storage: 'granted',
                              analytics_storage: selections.analytics ? 'granted' : 'denied',
                              personalization_storage: selections.personalization ? 'granted' : 'denied',
                              ad_personalization: selections.personalization ? 'granted' : 'denied',
                              ad_storage: selections.marketing ? 'granted' : 'denied',
                              ad_user_data: selections.marketing ? 'granted' : 'denied',
                              wait_for_update: 3000,
                            });
                          (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 || _window$gtag2.call(_window2, 'set', 'ads_data_redaction', !selections.marketing);
                          (_window$gtag3 = (_window3 = window).gtag) === null || _window$gtag3 === void 0 || _window$gtag3.call(_window3, 'set', 'url_passthrough', true);
                          window.dispatchEvent(new CustomEvent('edition:consent-default-set'));
                          _context.n = 1;
                          return _this.loadShopifyConsentApi();
                        case 1:
                          return _context.a(2);
                      }
                  }, _callee);
                })
              )
            );
            _defineProperty(_this, 'addEventListeners', function () {
              var _this$querySelector, _this$querySelector2, _this$querySelector3, _this$querySelector4, _this$querySelector5, _document$getElementB;
              (_this$querySelector = _this.querySelector('#tab-consent')) === null ||
                _this$querySelector === void 0 ||
                _this$querySelector.addEventListener('click', function () {
                  return _this.activateTab('consent');
                });
              (_this$querySelector2 = _this.querySelector('#tab-details')) === null ||
                _this$querySelector2 === void 0 ||
                _this$querySelector2.addEventListener('click', function () {
                  return _this.activateTab('details');
                });
              (_this$querySelector3 = _this.querySelector('.allow-all-btn')) === null || _this$querySelector3 === void 0 || _this$querySelector3.addEventListener('click', _this.handleAllowAll);
              (_this$querySelector4 = _this.querySelector('.allow-selected-btn')) === null || _this$querySelector4 === void 0 || _this$querySelector4.addEventListener('click', _this.handleAllowSelected);
              (_this$querySelector5 = _this.querySelector('[data-action="reject"]')) === null || _this$querySelector5 === void 0 || _this$querySelector5.addEventListener('click', _this.handleRejectAll);
              (_document$getElementB = document.getElementById('manage-cookie-consent')) === null ||
                _document$getElementB === void 0 ||
                _document$getElementB.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this.showBanner();
                });
            });
            _defineProperty(_this, 'activateTab', function (tab) {
              ['consent', 'details'].forEach(function (id) {
                var _this$querySelector6, _this$querySelector7, _this$querySelector8;
                (_this$querySelector6 = _this.querySelector('#tab-'.concat(id))) === null || _this$querySelector6 === void 0 || _this$querySelector6.classList.toggle('active', id === tab);
                (_this$querySelector7 = _this.querySelector('#panel-'.concat(id))) === null || _this$querySelector7 === void 0 || _this$querySelector7.classList.toggle('active', id === tab);
                (_this$querySelector8 = _this.querySelector('#panel-'.concat(id))) === null || _this$querySelector8 === void 0 || _this$querySelector8.classList.toggle('tw:hidden!', id !== tab);
              });
            });
            /**
             * Returns true if the banner should be shown.
             * Prefers localStorage over the Shopify API — if the user has a stored selection we trust it
             * and skip the async API call entirely.
             */
            _defineProperty(
              _this,
              'shouldShowBanner',
              /*#__PURE__*/ _asyncToGenerator(
                /*#__PURE__*/ _regenerator().m(function _callee2() {
                  var _window$Shopify;
                  var _yield$window$Shopify, preferences, analytics, marketing, _t;
                  return _regenerator().w(
                    function (_context2) {
                      while (1)
                        switch ((_context2.p = _context2.n)) {
                          case 0:
                            if (!_utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY)) {
                              _context2.n = 1;
                              break;
                            }
                            return _context2.a(2, false);
                          case 1:
                            if (!(!_this.consentApiReady || !((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.customerPrivacy) !== null && _window$Shopify !== void 0 && _window$Shopify.currentVisitorConsent))) {
                              _context2.n = 2;
                              break;
                            }
                            return _context2.a(2, true);
                          case 2:
                            _context2.p = 2;
                            _context2.n = 3;
                            return window.Shopify.customerPrivacy.currentVisitorConsent();
                          case 3:
                            _yield$window$Shopify = _context2.v;
                            preferences = _yield$window$Shopify.preferences;
                            analytics = _yield$window$Shopify.analytics;
                            marketing = _yield$window$Shopify.marketing;
                            return _context2.a(
                              2,
                              [preferences, analytics, marketing].every(function (v) {
                                return (v !== null && v !== void 0 ? v : '') === '';
                              })
                            );
                          case 4:
                            _context2.p = 4;
                            _t = _context2.v;
                            return _context2.a(2, true);
                        }
                    },
                    _callee2,
                    null,
                    [[2, 4]]
                  );
                })
              )
            );
            _defineProperty(_this, 'loadShopifyConsentApi', function () {
              var _window$Shopify2;
              if (!((_window$Shopify2 = window.Shopify) !== null && _window$Shopify2 !== void 0 && _window$Shopify2.loadFeatures)) {
                return Promise.resolve();
              }
              return new Promise(function (resolve) {
                try {
                  window.Shopify.loadFeatures(
                    [
                      {
                        name: 'consent-tracking-api',
                        version: '0.1',
                      },
                    ],
                    function (error) {
                      if (error) {
                        _utils_Logger__WEBPACK_IMPORTED_MODULE_1__['default'].error('Shopify consent-tracking-api failed to load', error);
                        resolve();
                        return;
                      }
                      _this.consentApiReady = true;
                      resolve();
                      document.addEventListener(
                        'visitorConsentCollected',
                        /*#__PURE__*/ _asyncToGenerator(
                          /*#__PURE__*/ _regenerator().m(function _callee3() {
                            var _window$Shopify3, _window$Shopify3$curr, v, _t2;
                            return _regenerator().w(
                              function (_context3) {
                                while (1)
                                  switch ((_context3.p = _context3.n)) {
                                    case 0:
                                      _context3.p = 0;
                                      _context3.n = 1;
                                      return (_window$Shopify3 = window.Shopify) === null ||
                                        _window$Shopify3 === void 0 ||
                                        (_window$Shopify3 = _window$Shopify3.customerPrivacy) === null ||
                                        _window$Shopify3 === void 0 ||
                                        (_window$Shopify3$curr = _window$Shopify3.currentVisitorConsent) === null ||
                                        _window$Shopify3$curr === void 0
                                        ? void 0
                                        : _window$Shopify3$curr.call(_window$Shopify3);
                                    case 1:
                                      v = _context3.v;
                                      if (v) {
                                        _context3.n = 2;
                                        break;
                                      }
                                      return _context3.a(2);
                                    case 2:
                                      _this.setConsentGroup({
                                        key: 'personalization',
                                        checked: v.preferences === 'yes',
                                      });
                                      _this.setConsentGroup({
                                        key: 'marketing',
                                        checked: v.marketing === 'yes',
                                      });
                                      _this.setConsentGroup({
                                        key: 'analytics',
                                        checked: v.analytics === 'yes',
                                      });
                                      _this.saveSelections();
                                      _context3.n = 4;
                                      break;
                                    case 3:
                                      _context3.p = 3;
                                      _t2 = _context3.v;
                                      _utils_Logger__WEBPACK_IMPORTED_MODULE_1__['default'].error('visitorConsentCollected handler error', _t2);
                                    case 4:
                                      return _context3.a(2);
                                  }
                              },
                              _callee3,
                              null,
                              [[0, 3]]
                            );
                          })
                        )
                      );
                    }
                  );
                } catch (e) {
                  _utils_Logger__WEBPACK_IMPORTED_MODULE_1__['default'].error('Shopify loadFeatures threw', e);
                  resolve();
                }
              });
            });
            /** Updates gtag consent, persists to localStorage, and fires `edition:consent-updated`. */
            _defineProperty(_this, 'applyConsent', function (_ref4) {
              var _window$gtag4, _window4, _window$gtag5, _window5, _window$Shopify4, _window$Shopify4$setT;
              var consent = _ref4.consent,
                hide = _ref4.hide;
              (_window$gtag4 = (_window4 = window).gtag) === null ||
                _window$gtag4 === void 0 ||
                _window$gtag4.call(_window4, 'consent', 'update', {
                  functionality_storage: 'granted',
                  analytics_storage: consent.analytics === 'yes' ? 'granted' : 'denied',
                  personalization_storage: consent.preferences === 'yes' ? 'granted' : 'denied',
                  ad_personalization: consent.preferences === 'yes' ? 'granted' : 'denied',
                  ad_storage: consent.marketing === 'yes' ? 'granted' : 'denied',
                  ad_user_data: consent.marketing === 'yes' ? 'granted' : 'denied',
                });
              (_window$gtag5 = (_window5 = window).gtag) === null || _window$gtag5 === void 0 || _window$gtag5.call(_window5, 'set', 'ads_data_redaction', consent.marketing !== 'yes');
              _this.saveSelections();
              window.dispatchEvent(new CustomEvent('edition:consent-updated'));
              (_window$Shopify4 = window.Shopify) === null ||
                _window$Shopify4 === void 0 ||
                (_window$Shopify4 = _window$Shopify4.customerPrivacy) === null ||
                _window$Shopify4 === void 0 ||
                (_window$Shopify4$setT = _window$Shopify4.setTrackingConsent) === null ||
                _window$Shopify4$setT === void 0 ||
                _window$Shopify4$setT.call(_window$Shopify4, {
                  analytics: consent.analytics === 'yes',
                  marketing: consent.marketing === 'yes',
                  preferences: consent.preferences === 'yes',
                });
              if (hide) {
                _this.hideBanner();
              }
            });
            _defineProperty(_this, 'handleAllowAll', function () {
              _this.querySelectorAll('input.ed-checkbox[data-consent]').forEach(function (cb) {
                if (!cb.disabled) {
                  cb.checked = true;
                }
              });
              _this.applyConsent({
                consent: {
                  preferences: 'yes',
                  marketing: 'yes',
                  analytics: 'yes',
                },
                hide: true,
              });
            });
            _defineProperty(_this, 'handleAllowSelected', function () {
              var _this$getSelections = _this.getSelections(),
                personalization = _this$getSelections.personalization,
                marketing = _this$getSelections.marketing,
                analytics = _this$getSelections.analytics;
              _this.applyConsent({
                consent: {
                  preferences: personalization ? 'yes' : 'no',
                  marketing: marketing ? 'yes' : 'no',
                  analytics: analytics ? 'yes' : 'no',
                },
                hide: true,
              });
            });
            _defineProperty(_this, 'handleRejectAll', function () {
              _this.applyConsent({
                consent: {
                  preferences: 'no',
                  marketing: 'no',
                  analytics: 'no',
                },
                hide: true,
              });
            });
            /** Keeps the consent/details tab panels in sync — the same consent key can appear in both tabs. */
            _defineProperty(_this, 'syncCheckboxGroups', function () {
              var checkboxes = Array.from(_this.querySelectorAll('input.ed-checkbox[data-consent]'));
              checkboxes.forEach(function (checkbox) {
                checkbox.addEventListener('change', function (_ref5) {
                  var currentTarget = _ref5.currentTarget;
                  var source = currentTarget;
                  checkboxes.forEach(function (other) {
                    if (other !== source && other.dataset.consent === source.dataset.consent && !other.disabled) {
                      other.checked = source.checked;
                    }
                  });
                });
              });
              var grouped = checkboxes.reduce(function (acc, cb) {
                var _acc$key;
                var key = cb.dataset.consent;
                ((_acc$key = acc[key]) !== null && _acc$key !== void 0 ? _acc$key : (acc[key] = [])).push(cb);
                return acc;
              }, {});
              Object.values(grouped).forEach(function (_ref6) {
                var _ref7 = _toArray(_ref6),
                  source = _ref7[0],
                  rest = _arrayLikeToArray(_ref7).slice(1);
                rest.forEach(function (cb) {
                  if (!cb.disabled) {
                    cb.checked = source.checked;
                  }
                });
              });
            });
            _defineProperty(_this, 'setConsentGroup', function (_ref8) {
              var key = _ref8.key,
                checked = _ref8.checked;
              _this.querySelectorAll('input.ed-checkbox[data-consent="'.concat(key, '"]')).forEach(function (cb) {
                if (!cb.disabled) {
                  cb.checked = checked;
                }
              });
            });
            _defineProperty(_this, 'saveSelections', function () {
              _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.set(CONSENT_STORAGE_KEY, _this.getSelections());
            });
            _defineProperty(_this, 'getSelections', function () {
              return CONSENT_KEYS.reduce(
                function (acc, key) {
                  var _this$querySelector9;
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, !!((_this$querySelector9 = _this.querySelector('input.ed-checkbox[data-consent="'.concat(key, '"]'))) !== null && _this$querySelector9 !== void 0 && _this$querySelector9.checked)));
                },
                {
                  personalization: false,
                  marketing: false,
                  analytics: false,
                }
              );
            });
            /**
             * Opens the banner. Applies any previously saved selections to the checkboxes first —
             * if nothing is stored, the HTML defaults remain as-is.
             * Can be triggered externally via `#manage-cookie-consent`.
             */
            _defineProperty(_this, 'showBanner', function () {
              var saved = _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY);
              if (saved) {
                CONSENT_KEYS.forEach(function (key) {
                  return _this.setConsentGroup({
                    key: key,
                    checked: saved[key],
                  });
                });
              }
              _this.overlay.removeAttribute('hidden');
              _this.overlay.classList.remove('tw:hidden!');
            });
            _defineProperty(_this, 'hideBanner', function () {
              _this.overlay.classList.add('tw:hidden!');
            });
            /** Creates a `window.gtag` shim that queues calls into `dataLayer` if the real gtag hasn't loaded yet. */
            // eslint-disable-next-line class-methods-use-this
            _defineProperty(_this, 'ensureGtag', function () {
              window.dataLayer = window.dataLayer || [];
              if (!window.gtag) {
                // function keyword is intentional — arrow functions have no `arguments` object,
                // but GTM's consent processing requires the IArguments shape, not a plain array.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, prefer-rest-params
                window.gtag = function gtag() {
                  // eslint-disable-next-line prefer-rest-params
                  window.dataLayer.push(arguments);
                };
              }
            });
            return _this;
          }
          _inherits(CookieBanner, _HTMLElement);
          return _createClass(CookieBanner, [
            {
              key: 'connectedCallback',
              value: (function () {
                var _connectedCallback = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee4() {
                    var _t3;
                    return _regenerator().w(
                      function (_context4) {
                        while (1)
                          switch (_context4.n) {
                            case 0:
                              _context4.n = 1;
                              return this.setupConsent();
                            case 1:
                              this.addEventListeners();
                              this.activateTab('consent');
                              this.syncCheckboxGroups();
                              _t3 = this.dataset.forceShow === 'true';
                              if (_t3) {
                                _context4.n = 3;
                                break;
                              }
                              _context4.n = 2;
                              return this.shouldShowBanner();
                            case 2:
                              _t3 = _context4.v;
                            case 3:
                              if (!_t3) {
                                _context4.n = 4;
                                break;
                              }
                              this.showBanner();
                            case 4:
                              return _context4.a(2);
                          }
                      },
                      _callee4,
                      this
                    );
                  })
                );
                function connectedCallback() {
                  return _connectedCallback.apply(this, arguments);
                }
                return connectedCallback;
              })(),
            },
            {
              key: 'overlay',
              get: function get() {
                var _this$querySelector0;
                return (_this$querySelector0 = this.querySelector('[data-cookie-overlay]')) !== null && _this$querySelector0 !== void 0 ? _this$querySelector0 : this;
              },
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ './resources/scripts/components/Geolocator.ts':
      /*!****************************************************!*\
  !*** ./resources/scripts/components/Geolocator.ts ***!
  \****************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Geolocator,
          /* harmony export */
        });
        /* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/CookieMethods */ './resources/scripts/utils/CookieMethods.ts');
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regenerator() {
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
            t,
            r = 'function' == typeof Symbol ? Symbol : {},
            n = r.iterator || '@@iterator',
            o = r.toStringTag || '@@toStringTag';
          function i(r, n, o, i) {
            var c = n && n.prototype instanceof Generator ? n : Generator,
              u = Object.create(c.prototype);
            return (
              _regeneratorDefine2(
                u,
                '_invoke',
                (function (r, n, o) {
                  var i,
                    c,
                    u,
                    f = 0,
                    p = o || [],
                    y = !1,
                    G = {
                      p: 0,
                      n: 0,
                      v: e,
                      a: d,
                      f: d.bind(e, 4),
                      d: function d(t, r) {
                        return ((i = t), (c = 0), (u = e), (G.n = r), a);
                      },
                    };
                  function d(r, n) {
                    for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
                      var o,
                        i = p[t],
                        d = G.p,
                        l = i[2];
                      r > 3 ? (o = l === n) && ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]), (i[4] = i[5] = e)) : i[0] <= d && ((o = r < 2 && d < i[1]) ? ((c = 0), (G.v = n), (G.n = i[1])) : d < l && (o = r < 3 || i[0] > n || n > l) && ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                    }
                    if (o || r > 1) return a;
                    throw ((y = !0), n);
                  }
                  return function (o, p, l) {
                    if (f > 1) throw TypeError('Generator is already running');
                    for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y; ) {
                      i || (c ? (c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : (G.n = u)) : (G.v = u));
                      try {
                        if (((f = 2), i)) {
                          if ((c || (o = 'next'), (t = i[o]))) {
                            if (!(t = t.call(i, u))) throw TypeError('iterator result is not an object');
                            if (!t.done) return t;
                            ((u = t.value), c < 2 && (c = 0));
                          } else (1 === c && (t = i['return']) && t.call(i), c < 2 && ((u = TypeError("The iterator does not provide a '" + o + "' method")), (c = 1)));
                          i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                      } catch (t) {
                        ((i = e), (c = 1), (u = t));
                      } finally {
                        f = 1;
                      }
                    }
                    return { value: t, done: y };
                  };
                })(r, o, i),
                !0
              ),
              u
            );
          }
          var a = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          t = Object.getPrototypeOf;
          var c = [][n]
              ? t(t([][n]()))
              : (_regeneratorDefine2((t = {}), n, function () {
                  return this;
                }),
                t),
            u = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c));
          function f(e) {
            return (Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : ((e.__proto__ = GeneratorFunctionPrototype), _regeneratorDefine2(e, o, 'GeneratorFunction')), (e.prototype = Object.create(u)), e);
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            _regeneratorDefine2(u, 'constructor', GeneratorFunctionPrototype),
            _regeneratorDefine2(GeneratorFunctionPrototype, 'constructor', GeneratorFunction),
            (GeneratorFunction.displayName = 'GeneratorFunction'),
            _regeneratorDefine2(GeneratorFunctionPrototype, o, 'GeneratorFunction'),
            _regeneratorDefine2(u),
            _regeneratorDefine2(u, o, 'Generator'),
            _regeneratorDefine2(u, n, function () {
              return this;
            }),
            _regeneratorDefine2(u, 'toString', function () {
              return '[object Generator]';
            }),
            (_regenerator = function _regenerator() {
              return { w: i, m: f };
            })()
          );
        }
        function _regeneratorDefine2(e, r, n, t) {
          var i = Object.defineProperty;
          try {
            i({}, '', {});
          } catch (e) {
            i = 0;
          }
          ((_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
            function o(r, n) {
              _regeneratorDefine2(e, r, function (e) {
                return this._invoke(r, n, e);
              });
            }
            r ? (i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : (e[r] = n)) : (o('next', 0), o('throw', 1), o('return', 2));
          }),
            _regeneratorDefine2(e, r, n, t));
        }
        function asyncGeneratorStep(n, t, e, r, o, a, c) {
          try {
            var i = n[a](c),
              u = i.value;
          } catch (n) {
            return void e(n);
          }
          i.done ? t(u) : Promise.resolve(u).then(r, o);
        }
        function _asyncToGenerator(n) {
          return function () {
            var t = this,
              e = arguments;
            return new Promise(function (r, o) {
              var a = n.apply(t, e);
              function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'next', n);
              }
              function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'throw', n);
              }
              _next(void 0);
            });
          };
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _callSuper(t, o, e) {
          return ((o = _getPrototypeOf(o)), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)));
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
          if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function _inherits(t, e) {
          if ('function' != typeof e && null !== e) throw new TypeError('Super expression must either be null or a function');
          ((t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, 'prototype', { writable: !1 }), e && _setPrototypeOf(t, e));
        }
        function _wrapNativeSuper(t) {
          var r = 'function' == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(t, arguments, _getPrototypeOf(this).constructor);
              }
              return ((Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(Wrapper, t));
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return (r && _setPrototypeOf(p, r.prototype), p);
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
            return !!t;
          })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf('[native code]');
          } catch (n) {
            return 'function' == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return ((t.__proto__ = e), t);
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }

        var Geolocator = /*#__PURE__*/ (function (_HTMLElement) {
          function Geolocator() {
            var _this;
            _classCallCheck(this, Geolocator);
            _this = _callSuper(this, Geolocator);
            _defineProperty(_this, 'countryData', void 0);
            _defineProperty(_this, 'url', window.location.href);
            _this.countryData = window.countryData;
            // bind the methods to the class
            _this.getSelectedCountry = _this.getSelectedCountry.bind(_this);
            _this.getVisitorCountry = _this.getVisitorCountry.bind(_this);
            _this.showGeoPopup = _this.showGeoPopup.bind(_this);
            _this.handleClickedStayButton = _this.handleClickedStayButton.bind(_this);
            _this.handleClickedRedirectButton = _this.handleClickedRedirectButton.bind(_this);
            _this.checkUrlForParam = _this.checkUrlForParam.bind(_this);
            return _this;
          }
          _inherits(Geolocator, _HTMLElement);
          return _createClass(Geolocator, [
            {
              key: 'connectedCallback',
              value: (function () {
                var _connectedCallback = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee() {
                    var editionGeoCookie, editionGeoSwitchCookie, _window, countryData, selectedCountry, visitorCountry, visitorCountryIsInCountryData, primaryCountryDataInCountryData, visitorCountryDataInCountryData;
                    return _regenerator().w(
                      function (_context) {
                        while (1)
                          switch (_context.n) {
                            case 0:
                              this.checkUrlForParam();
                              editionGeoCookie = (0, _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geocookie');
                              editionGeoSwitchCookie = (0, _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geoswitch');
                              if (!(editionGeoCookie || editionGeoSwitchCookie || Shopify.designMode === true)) {
                                _context.n = 1;
                                break;
                              }
                              return _context.a(2);
                            case 1:
                              ((_window = window), (countryData = _window.countryData));
                              selectedCountry = this.getSelectedCountry();
                              console.log('selectedCountry', selectedCountry);
                              _context.n = 2;
                              return this.getVisitorCountry();
                            case 2:
                              visitorCountry = _context.v;
                              console.log('visitorCountry', visitorCountry);
                              if (!((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryCode) === visitorCountry.handle)) {
                                _context.n = 3;
                                break;
                              }
                              _context.n = 6;
                              break;
                            case 3:
                              visitorCountryIsInCountryData = countryData.some(function (country) {
                                return country.countryCode === visitorCountry.handle;
                              });
                              if (visitorCountryIsInCountryData) {
                                _context.n = 5;
                                break;
                              }
                              primaryCountryDataInCountryData = countryData.find(function (country) {
                                return country.primaryCountry === true;
                              });
                              if (!((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryCode) === primaryCountryDataInCountryData.countryCode)) {
                                _context.n = 4;
                                break;
                              }
                              return _context.a(2);
                            case 4:
                              this.showGeoPopup(primaryCountryDataInCountryData);
                              _context.n = 6;
                              break;
                            case 5:
                              visitorCountryDataInCountryData = countryData.find(function (country) {
                                return country.countryCode === visitorCountry.handle;
                              });
                              this.showGeoPopup(visitorCountryDataInCountryData);
                            case 6:
                              return _context.a(2);
                          }
                      },
                      _callee,
                      this
                    );
                  })
                );
                function connectedCallback() {
                  return _connectedCallback.apply(this, arguments);
                }
                return connectedCallback;
              })(),
            },
            {
              key: 'getSelectedCountry',
              value: function getSelectedCountry() {
                var countryDataArray = this.countryData;
                var selectedCountry = countryDataArray.find(function (country) {
                  return country.locale === Shopify.locale;
                });
                return selectedCountry;
              },
            },
            {
              key: 'getVisitorCountry',
              value: (function () {
                var _getVisitorCountry = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee2() {
                    var response, data, visitorCountry;
                    return _regenerator().w(
                      function (_context2) {
                        while (1)
                          switch (_context2.n) {
                            case 0:
                              _context2.n = 1;
                              return fetch('/browsing_context_suggestions.json');
                            case 1:
                              response = _context2.v;
                              _context2.n = 2;
                              return response.json();
                            case 2:
                              data = _context2.v;
                              visitorCountry = data.detected_values.country;
                              this.setAttribute('data-visitor-country', visitorCountry.handle);
                              return _context2.a(2, visitorCountry);
                          }
                      },
                      _callee2,
                      this
                    );
                  })
                );
                function getVisitorCountry() {
                  return _getVisitorCountry.apply(this, arguments);
                }
                return getVisitorCountry;
              })(),
            },
            {
              key: 'showGeoPopup',
              value: function showGeoPopup(countryObject) {
                var _this2 = this;
                console.log('showGeoPopup', countryObject);
                this.classList.remove('tw-z-[-1]');
                this.classList.add('tw-z-[100]');
                setTimeout(function () {
                  _this2.classList.add('!tw-opacity-100');
                }, 500);
                var layout = this.dataset.layout;
                if (layout === 'primary') {
                  var img = this.querySelector('#geolocator-flag');
                  var heading = this.querySelector('#geolocator-heading');
                  var richtext = this.querySelector('#geolocator-richtext');
                  var buttonRedirect = this.querySelector('#geolocator-button-redirect');
                  var buttonStay = this.querySelector('#geolocator-button-stay');
                  if (img) {
                    img.src = countryObject.flag;
                  }
                  heading.innerHTML = countryObject.heading;
                  richtext.innerText = countryObject.richtext;
                  buttonRedirect.innerHTML = countryObject.button_one;
                  buttonStay.innerHTML = countryObject.button_two;
                  // If the user clicks the "redirect" button, redirect to the selected country or market
                  buttonRedirect.addEventListener('click', this.handleClickedRedirectButton.bind(this, countryObject.link));
                  // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
                  buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
                } else {
                  var _heading = this.querySelector('#geolocator-heading');
                  var _richtext = this.querySelector('#geolocator-richtext');
                  var _buttonStay = this.querySelector('#geolocator-button-stay');
                  this.SortAndOrderCountries(countryObject);
                  _heading.innerHTML = countryObject.heading;
                  _richtext.innerHTML = countryObject.richtext;
                  _buttonStay.innerHTML = countryObject.button_two;
                  // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
                  _buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
                }
              },
            },
            {
              key: 'handleClickedStayButton',
              value: function handleClickedStayButton() {
                var _this3 = this;
                this.classList.remove('tw-opacity-100');
                this.classList.add('tw-opacity-0');
                (0, _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geocookie', 'true', 10);
                setTimeout(function () {
                  _this3.remove();
                }, 1000);
              },
            },
            {
              key: 'handleClickedRedirectButton',
              value: function handleClickedRedirectButton(redirectUrl) {
                this.remove();
                window.location.href = redirectUrl;
              },
            },
            {
              key: 'checkUrlForParam',
              value: function checkUrlForParam() {
                if (this.url.includes('?edition-geoswitch')) {
                  (0, _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geoswitch', 'true', 10);
                }
              },
            },
            {
              key: 'SortAndOrderCountries',
              value: function SortAndOrderCountries(countryObject) {
                var currentCountryListHolder = this.querySelector('#geolocator-country-list');
                var currentCountryList = Array.from(currentCountryListHolder.querySelectorAll('.geolocator_country'));
                // Each geolocator_country has a data-locale attribute. Sort the currentCountryList based on the data-locale attribute so the country that has the same locale as the countryObject is first in the list
                currentCountryList.sort(function (a, b) {
                  if (a.dataset.locale === countryObject.locale) {
                    return -1;
                  }
                  if (b.dataset.locale === countryObject.locale) {
                    return 1;
                  }
                  return 0;
                });
                // Add the sorted list back to the DOM
                currentCountryList.forEach(function (country) {
                  currentCountryListHolder.appendChild(country);
                });
              },
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ './resources/scripts/components/InventoryDeliveryComponent/InventoryDeliveryComponent.ts':
      /*!***********************************************************************************************!*\
  !*** ./resources/scripts/components/InventoryDeliveryComponent/InventoryDeliveryComponent.ts ***!
  \***********************************************************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ InventoryDeliveryComponent,
          /* harmony export */
        });
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regenerator() {
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
            t,
            r = 'function' == typeof Symbol ? Symbol : {},
            n = r.iterator || '@@iterator',
            o = r.toStringTag || '@@toStringTag';
          function i(r, n, o, i) {
            var c = n && n.prototype instanceof Generator ? n : Generator,
              u = Object.create(c.prototype);
            return (
              _regeneratorDefine2(
                u,
                '_invoke',
                (function (r, n, o) {
                  var i,
                    c,
                    u,
                    f = 0,
                    p = o || [],
                    y = !1,
                    G = {
                      p: 0,
                      n: 0,
                      v: e,
                      a: d,
                      f: d.bind(e, 4),
                      d: function d(t, r) {
                        return ((i = t), (c = 0), (u = e), (G.n = r), a);
                      },
                    };
                  function d(r, n) {
                    for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
                      var o,
                        i = p[t],
                        d = G.p,
                        l = i[2];
                      r > 3 ? (o = l === n) && ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]), (i[4] = i[5] = e)) : i[0] <= d && ((o = r < 2 && d < i[1]) ? ((c = 0), (G.v = n), (G.n = i[1])) : d < l && (o = r < 3 || i[0] > n || n > l) && ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                    }
                    if (o || r > 1) return a;
                    throw ((y = !0), n);
                  }
                  return function (o, p, l) {
                    if (f > 1) throw TypeError('Generator is already running');
                    for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y; ) {
                      i || (c ? (c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : (G.n = u)) : (G.v = u));
                      try {
                        if (((f = 2), i)) {
                          if ((c || (o = 'next'), (t = i[o]))) {
                            if (!(t = t.call(i, u))) throw TypeError('iterator result is not an object');
                            if (!t.done) return t;
                            ((u = t.value), c < 2 && (c = 0));
                          } else (1 === c && (t = i['return']) && t.call(i), c < 2 && ((u = TypeError("The iterator does not provide a '" + o + "' method")), (c = 1)));
                          i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                      } catch (t) {
                        ((i = e), (c = 1), (u = t));
                      } finally {
                        f = 1;
                      }
                    }
                    return { value: t, done: y };
                  };
                })(r, o, i),
                !0
              ),
              u
            );
          }
          var a = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          t = Object.getPrototypeOf;
          var c = [][n]
              ? t(t([][n]()))
              : (_regeneratorDefine2((t = {}), n, function () {
                  return this;
                }),
                t),
            u = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c));
          function f(e) {
            return (Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : ((e.__proto__ = GeneratorFunctionPrototype), _regeneratorDefine2(e, o, 'GeneratorFunction')), (e.prototype = Object.create(u)), e);
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            _regeneratorDefine2(u, 'constructor', GeneratorFunctionPrototype),
            _regeneratorDefine2(GeneratorFunctionPrototype, 'constructor', GeneratorFunction),
            (GeneratorFunction.displayName = 'GeneratorFunction'),
            _regeneratorDefine2(GeneratorFunctionPrototype, o, 'GeneratorFunction'),
            _regeneratorDefine2(u),
            _regeneratorDefine2(u, o, 'Generator'),
            _regeneratorDefine2(u, n, function () {
              return this;
            }),
            _regeneratorDefine2(u, 'toString', function () {
              return '[object Generator]';
            }),
            (_regenerator = function _regenerator() {
              return { w: i, m: f };
            })()
          );
        }
        function _regeneratorDefine2(e, r, n, t) {
          var i = Object.defineProperty;
          try {
            i({}, '', {});
          } catch (e) {
            i = 0;
          }
          ((_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
            function o(r, n) {
              _regeneratorDefine2(e, r, function (e) {
                return this._invoke(r, n, e);
              });
            }
            r ? (i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : (e[r] = n)) : (o('next', 0), o('throw', 1), o('return', 2));
          }),
            _regeneratorDefine2(e, r, n, t));
        }
        function asyncGeneratorStep(n, t, e, r, o, a, c) {
          try {
            var i = n[a](c),
              u = i.value;
          } catch (n) {
            return void e(n);
          }
          i.done ? t(u) : Promise.resolve(u).then(r, o);
        }
        function _asyncToGenerator(n) {
          return function () {
            var t = this,
              e = arguments;
            return new Promise(function (r, o) {
              var a = n.apply(t, e);
              function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'next', n);
              }
              function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'throw', n);
              }
              _next(void 0);
            });
          };
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _callSuper(t, o, e) {
          return ((o = _getPrototypeOf(o)), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)));
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
          if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function _inherits(t, e) {
          if ('function' != typeof e && null !== e) throw new TypeError('Super expression must either be null or a function');
          ((t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, 'prototype', { writable: !1 }), e && _setPrototypeOf(t, e));
        }
        function _wrapNativeSuper(t) {
          var r = 'function' == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(t, arguments, _getPrototypeOf(this).constructor);
              }
              return ((Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(Wrapper, t));
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return (r && _setPrototypeOf(p, r.prototype), p);
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
            return !!t;
          })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf('[native code]');
          } catch (n) {
            return 'function' == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return ((t.__proto__ = e), t);
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }
        var InventoryDeliveryComponent = /*#__PURE__*/ (function (_HTMLElement) {
          function InventoryDeliveryComponent() {
            var _this;
            _classCallCheck(this, InventoryDeliveryComponent);
            _this = _callSuper(this, InventoryDeliveryComponent);
            _defineProperty(_this, 'productUrl', _this.dataset.producturl);
            _this.addEventListeners = _this.addEventListeners.bind(_this);
            _this.handleComponentUpdate = _this.handleComponentUpdate.bind(_this);
            return _this;
          }
          _inherits(InventoryDeliveryComponent, _HTMLElement);
          return _createClass(InventoryDeliveryComponent, [
            {
              key: 'connectedCallback',
              value: function connectedCallback() {
                this.addEventListeners();
                console.log('InventoryDeliveryComponent connected');
              },
            },
            {
              key: 'addEventListeners',
              value: function addEventListeners() {
                var _this2 = this;
                // listen for variant change event. Must be dispatched from the themes variant selectors
                // make sure eventlisteners are added only once
                document.addEventListener('variant:changed', function (event) {
                  var variantId = event.detail.variant.id;
                  _this2.handleComponentUpdate(variantId);
                });
              },
              // eslint-disable-next-line class-methods-use-this
            },
            {
              key: 'handleComponentUpdate',
              value: (function () {
                var _handleComponentUpdate = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee(variantId) {
                    var baseUrl, response, error, data, freshComponent, currentComponent, _t;
                    return _regenerator().w(
                      function (_context) {
                        while (1)
                          switch ((_context.p = _context.n)) {
                            case 0:
                              baseUrl = 'https://'.concat(Shopify.shop).concat(this.productUrl, '?variant=').concat(variantId); // fetch the updated product page and get our specific component from the returned data
                              _context.p = 1;
                              _context.n = 2;
                              return fetch(''.concat(baseUrl, '?section_id=main-product'));
                            case 2:
                              response = _context.v;
                              if (response.ok) {
                                _context.n = 3;
                                break;
                              }
                              error = new Error('HTTP error! status: '.concat(response.status));
                              throw error;
                            case 3:
                              _context.n = 4;
                              return response.text();
                            case 4:
                              data = _context.v;
                              freshComponent = new DOMParser().parseFromString(data, 'text/html').querySelector('inventory-delivery-component'); // check if the component exists on the page
                              if (freshComponent) {
                                // get the current component on the page
                                currentComponent = document.querySelector('inventory-delivery-component'); // unless the component is the same, replace it with the new one
                                if (currentComponent !== freshComponent) {
                                  currentComponent.replaceWith(freshComponent);
                                }
                              }
                              _context.n = 6;
                              break;
                            case 5:
                              _context.p = 5;
                              _t = _context.v;
                              console.error('Error fetching product page', _t);
                            case 6:
                              return _context.a(2);
                          }
                      },
                      _callee,
                      this,
                      [[1, 5]]
                    );
                  })
                );
                function handleComponentUpdate(_x) {
                  return _handleComponentUpdate.apply(this, arguments);
                }
                return handleComponentUpdate;
              })(),
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ './resources/scripts/components/PeekHint.ts':
      /*!**************************************************!*\
  !*** ./resources/scripts/components/PeekHint.ts ***!
  \**************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ initPeekHint,
          /* harmony export */
        });
        var SLIDE_MS = 480;
        var HOLD_MS = 850;
        function initPeekHint() {
          var run = function run() {
            var _candidates$find;
            // Cards marked no-peek-hint opt out (see snippets/product-item.liquid,
            // rendered with disable_peek_hint: true).
            var candidates = Array.from(document.querySelectorAll('.product-list__inner product-item:not([no-peek-hint])'));
            var target =
              (_candidates$find = candidates.find(function (item) {
                var sec = item.querySelector('.product-item__secondary-image');
                return sec && sec.getAttribute('src');
              })) !== null && _candidates$find !== void 0
                ? _candidates$find
                : null;
            if (!target) return;
            var aspectRatio = target.querySelector('.product-item__aspect-ratio');
            var primary = target.querySelector('.product-item__primary-image');
            var secondary = target.querySelector('.product-item__secondary-image');
            if (!aspectRatio || !primary || !secondary) return;
            var primarySrc = primary.getAttribute('src');
            var secondarySrc = secondary.getAttribute('src');
            if (!primarySrc || !secondarySrc) return;
            // A 200%-wide strip holds both images side by side.
            // Translating the strip by -15% of its own width = -30% of the container,
            // so the primary panel slides left 30% and the secondary panel peeks in 30%
            // as one seamlessly connected surface — no need to animate the real images.
            var strip = document.createElement('div');
            var ss = strip.style;
            ss.position = 'absolute';
            ss.top = '0';
            ss.left = '0';
            ss.width = '200%';
            ss.height = '100%';
            ss.display = 'flex';
            ss.transform = 'translateX(0)';
            ss.transition = 'none';
            ss.willChange = 'transform';
            ss.pointerEvents = 'none';
            ss.zIndex = '1';
            var makePanel = function makePanel(src) {
              var panel = document.createElement('div');
              panel.style.width = '50%';
              panel.style.height = '100%';
              panel.style.flexShrink = '0';
              panel.style.backgroundImage = 'url('.concat(src, ')');
              panel.style.backgroundSize = 'cover';
              panel.style.backgroundPosition = 'center';
              panel.style.backgroundRepeat = 'no-repeat';
              return panel;
            };
            strip.appendChild(makePanel(primarySrc));
            strip.appendChild(makePanel(secondarySrc));
            aspectRatio.appendChild(strip);
            // Force a layout flush so the browser commits translateX(0) as the start state.
            strip.getBoundingClientRect();
            // Slide the strip so the secondary panel peeks in 30% from the right.
            strip.style.transition = 'transform '.concat(SLIDE_MS, 'ms ease-in-out');
            strip.style.transform = 'translateX(-15%)';
            setTimeout(function () {
              strip.style.transform = 'translateX(0)';
              setTimeout(function () {
                strip.remove();
              }, SLIDE_MS + 60);
            }, HOLD_MS);
          };
          // Runs on the visitor's first scroll instead of on a timer, so the
          // hint is shown to someone who is actually looking at the page.
          // Fires once per page load.
          var startOnFirstScroll = function startOnFirstScroll() {
            var onFirstScroll = function onFirstScroll() {
              window.removeEventListener('scroll', onFirstScroll);
              run();
            };
            window.addEventListener('scroll', onFirstScroll, {
              passive: true,
              once: true,
            });
          };
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', startOnFirstScroll);
          } else {
            startOnFirstScroll();
          }
        }

        /***/
      },

    /***/ './resources/scripts/components/ProductUpsell/ProductUpsell.ts':
      /*!*********************************************************************!*\
  !*** ./resources/scripts/components/ProductUpsell/ProductUpsell.ts ***!
  \*********************************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ ProductUpsell,
          /* harmony export */
        });
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _callSuper(t, o, e) {
          return ((o = _getPrototypeOf(o)), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)));
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
          if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function _inherits(t, e) {
          if ('function' != typeof e && null !== e) throw new TypeError('Super expression must either be null or a function');
          ((t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, 'prototype', { writable: !1 }), e && _setPrototypeOf(t, e));
        }
        function _wrapNativeSuper(t) {
          var r = 'function' == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(t, arguments, _getPrototypeOf(this).constructor);
              }
              return ((Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(Wrapper, t));
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return (r && _setPrototypeOf(p, r.prototype), p);
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
            return !!t;
          })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf('[native code]');
          } catch (n) {
            return 'function' == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return ((t.__proto__ = e), t);
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }
        var ProductUpsell = /*#__PURE__*/ (function (_HTMLElement) {
          function ProductUpsell() {
            var _this;
            _classCallCheck(this, ProductUpsell);
            _this = _callSuper(this, ProductUpsell);
            _defineProperty(_this, 'quantity', 1);
            _defineProperty(_this, 'maxQuantity', Infinity);
            _defineProperty(_this, 'active', false);
            _defineProperty(_this, 'mainCheckbox', null);
            _defineProperty(_this, 'qtyStepper', null);
            _defineProperty(_this, 'quantityDisplay', null);
            _defineProperty(_this, 'quantityInput', null);
            _defineProperty(_this, 'variantSelect', null);
            _defineProperty(_this, 'variantIdInput', null);
            _defineProperty(_this, 'decreaseBtn', null);
            _defineProperty(_this, 'increaseBtn', null);
            _defineProperty(_this, 'hiddenInputs', []);
            _defineProperty(_this, 'variantInventoryMap', new Map());
            _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
            _this.handleDecrease = _this.handleDecrease.bind(_this);
            _this.handleIncrease = _this.handleIncrease.bind(_this);
            _this.handleVariantChange = _this.handleVariantChange.bind(_this);
            return _this;
          }
          _inherits(ProductUpsell, _HTMLElement);
          return _createClass(ProductUpsell, [
            {
              key: 'connectedCallback',
              value: function connectedCallback() {
                var _this2 = this,
                  _this$mainCheckbox,
                  _this$decreaseBtn,
                  _this$increaseBtn,
                  _this$variantSelect,
                  _this$variantSelect2;
                this.mainCheckbox = this.querySelector('[data-main-checkbox]');
                this.qtyStepper = this.querySelector('[data-qty-stepper]');
                this.quantityDisplay = this.querySelector('[data-quantity]');
                this.quantityInput = this.querySelector('[data-quantity-input]');
                this.variantSelect = this.querySelector('[data-variant-select]');
                this.variantIdInput = this.querySelector('[data-variant-id-input]');
                this.decreaseBtn = this.querySelector('[data-action="decrease"]');
                this.increaseBtn = this.querySelector('[data-action="increase"]');
                this.hiddenInputs = Array.from(this.querySelectorAll('input[type="hidden"]'));
                var variantsAttr = this.getAttribute('data-variants');
                if (variantsAttr) {
                  try {
                    var parsed = JSON.parse(variantsAttr);
                    parsed.forEach(function (v) {
                      _this2.variantInventoryMap.set(String(v.id), {
                        id: String(v.id),
                        inventory: v.inventory,
                        policy: v.policy,
                      });
                    });
                  } catch (_) {
                    // ignore malformed JSON
                  }
                }
                (_this$mainCheckbox = this.mainCheckbox) === null || _this$mainCheckbox === void 0 || _this$mainCheckbox.addEventListener('change', this.handleCheckboxChange);
                (_this$decreaseBtn = this.decreaseBtn) === null || _this$decreaseBtn === void 0 || _this$decreaseBtn.addEventListener('click', this.handleDecrease);
                (_this$increaseBtn = this.increaseBtn) === null || _this$increaseBtn === void 0 || _this$increaseBtn.addEventListener('click', this.handleIncrease);
                (_this$variantSelect = this.variantSelect) === null || _this$variantSelect === void 0 || _this$variantSelect.addEventListener('change', this.handleVariantChange);
                (_this$variantSelect2 = this.variantSelect) === null ||
                  _this$variantSelect2 === void 0 ||
                  _this$variantSelect2.addEventListener('click', function (e) {
                    return e.stopPropagation();
                  });
                this.syncMaxQuantity();
                this.updateState();
              },
            },
            {
              key: 'disconnectedCallback',
              value: function disconnectedCallback() {
                var _this$mainCheckbox2, _this$decreaseBtn2, _this$increaseBtn2, _this$variantSelect3;
                (_this$mainCheckbox2 = this.mainCheckbox) === null || _this$mainCheckbox2 === void 0 || _this$mainCheckbox2.removeEventListener('change', this.handleCheckboxChange);
                (_this$decreaseBtn2 = this.decreaseBtn) === null || _this$decreaseBtn2 === void 0 || _this$decreaseBtn2.removeEventListener('click', this.handleDecrease);
                (_this$increaseBtn2 = this.increaseBtn) === null || _this$increaseBtn2 === void 0 || _this$increaseBtn2.removeEventListener('click', this.handleIncrease);
                (_this$variantSelect3 = this.variantSelect) === null || _this$variantSelect3 === void 0 || _this$variantSelect3.removeEventListener('change', this.handleVariantChange);
              },
            },
            {
              key: 'syncMaxQuantity',
              value: function syncMaxQuantity() {
                var _this$variantIdInput;
                var variantId = (_this$variantIdInput = this.variantIdInput) === null || _this$variantIdInput === void 0 ? void 0 : _this$variantIdInput.value;
                if (variantId && this.variantInventoryMap.has(variantId)) {
                  var _this$variantInventor = this.variantInventoryMap.get(variantId),
                    inventory = _this$variantInventor.inventory,
                    policy = _this$variantInventor.policy;
                  this.maxQuantity = policy === 'continue' ? Infinity : Math.max(1, inventory);
                } else {
                  this.maxQuantity = Infinity;
                }
                if (this.quantity > this.maxQuantity) {
                  this.quantity = this.maxQuantity;
                }
              },
            },
            {
              key: 'handleCheckboxChange',
              value: function handleCheckboxChange() {
                var _this$mainCheckbox$ch, _this$mainCheckbox3;
                this.setActive((_this$mainCheckbox$ch = (_this$mainCheckbox3 = this.mainCheckbox) === null || _this$mainCheckbox3 === void 0 ? void 0 : _this$mainCheckbox3.checked) !== null && _this$mainCheckbox$ch !== void 0 ? _this$mainCheckbox$ch : false);
              },
            },
            {
              key: 'handleDecrease',
              value: function handleDecrease(event) {
                event.preventDefault();
                event.stopPropagation();
                if (this.quantity <= 1) {
                  this.setActive(false);
                  return;
                }
                this.quantity -= 1;
                this.updateState();
              },
            },
            {
              key: 'handleIncrease',
              value: function handleIncrease(event) {
                event.preventDefault();
                event.stopPropagation();
                if (this.quantity >= this.maxQuantity) return;
                this.quantity += 1;
                this.updateState();
              },
            },
            {
              key: 'handleVariantChange',
              value: function handleVariantChange(event) {
                event.stopPropagation();
                if (this.variantIdInput && this.variantSelect) {
                  this.variantIdInput.value = this.variantSelect.value;
                }
                this.syncMaxQuantity();
                if (!this.active) {
                  this.setActive(true);
                } else {
                  this.updateState();
                }
              },
            },
            {
              key: 'setActive',
              value: function setActive(value) {
                this.active = value;
                if (value) {
                  this.quantity = Math.max(1, this.quantity);
                }
                this.updateState();
              },
            },
            {
              key: 'updateState',
              value: function updateState() {
                var active = this.active,
                  quantity = this.quantity,
                  maxQuantity = this.maxQuantity;
                if (this.mainCheckbox) {
                  this.mainCheckbox.checked = active;
                }
                if (this.quantityInput) {
                  this.quantityInput.value = String(quantity);
                  this.quantityInput.disabled = !active;
                }
                this.hiddenInputs.forEach(function (input) {
                  // eslint-disable-next-line no-param-reassign
                  input.disabled = !active;
                });
                if (this.quantityDisplay) {
                  this.quantityDisplay.textContent = String(quantity);
                }
                if (this.increaseBtn) {
                  this.increaseBtn.disabled = quantity >= maxQuantity;
                }
                if (this.qtyStepper) {
                  this.qtyStepper.style.display = active ? 'flex' : 'none';
                }
                this.toggleAttribute('active', active);
              },
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ './resources/scripts/components/ScrollToggle.ts':
      /*!******************************************************!*\
  !*** ./resources/scripts/components/ScrollToggle.ts ***!
  \******************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ ScrollToggle,
          /* harmony export */
        });
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }
        var ScrollToggle = /*#__PURE__*/ (function () {
          function ScrollToggle() {
            _classCallCheck(this, ScrollToggle);
            _defineProperty(this, 'scrollToggles', Array.from(document.querySelectorAll('.scroll-toggle')));
            this.init = this.init.bind(this);
            this.handleToggleClick = this.handleToggleClick.bind(this);
          }
          return _createClass(ScrollToggle, [
            {
              key: 'init',
              value: function init() {
                var _this = this;
                if (!this.scrollToggles.length) return;
                this.scrollToggles.forEach(function (toggle) {
                  toggle.addEventListener('click', function (event) {
                    event.preventDefault();
                    _this.handleToggleClick(toggle);
                  });
                });
              },
              // eslint-disable-next-line class-methods-use-this
            },
            {
              key: 'handleToggleClick',
              value: function handleToggleClick(toggle) {
                var target = toggle.dataset.target;
                var targetElement = document.querySelector(target);
                if (!targetElement) return;
                // scroll to the target and subtract a few px
                window.scrollTo({
                  top: targetElement.offsetTop - 100,
                  behavior: 'smooth',
                });
              },
            },
          ]);
        })();

        /***/
      },

    /***/ './resources/scripts/components/ThumbnailDots/ThumbnailDots.ts':
      /*!*********************************************************************!*\
  !*** ./resources/scripts/components/ThumbnailDots/ThumbnailDots.ts ***!
  \*********************************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ ThumbnailDots,
          /* harmony export */
        });
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regenerator() {
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
            t,
            r = 'function' == typeof Symbol ? Symbol : {},
            n = r.iterator || '@@iterator',
            o = r.toStringTag || '@@toStringTag';
          function i(r, n, o, i) {
            var c = n && n.prototype instanceof Generator ? n : Generator,
              u = Object.create(c.prototype);
            return (
              _regeneratorDefine2(
                u,
                '_invoke',
                (function (r, n, o) {
                  var i,
                    c,
                    u,
                    f = 0,
                    p = o || [],
                    y = !1,
                    G = {
                      p: 0,
                      n: 0,
                      v: e,
                      a: d,
                      f: d.bind(e, 4),
                      d: function d(t, r) {
                        return ((i = t), (c = 0), (u = e), (G.n = r), a);
                      },
                    };
                  function d(r, n) {
                    for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
                      var o,
                        i = p[t],
                        d = G.p,
                        l = i[2];
                      r > 3 ? (o = l === n) && ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]), (i[4] = i[5] = e)) : i[0] <= d && ((o = r < 2 && d < i[1]) ? ((c = 0), (G.v = n), (G.n = i[1])) : d < l && (o = r < 3 || i[0] > n || n > l) && ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                    }
                    if (o || r > 1) return a;
                    throw ((y = !0), n);
                  }
                  return function (o, p, l) {
                    if (f > 1) throw TypeError('Generator is already running');
                    for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y; ) {
                      i || (c ? (c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : (G.n = u)) : (G.v = u));
                      try {
                        if (((f = 2), i)) {
                          if ((c || (o = 'next'), (t = i[o]))) {
                            if (!(t = t.call(i, u))) throw TypeError('iterator result is not an object');
                            if (!t.done) return t;
                            ((u = t.value), c < 2 && (c = 0));
                          } else (1 === c && (t = i['return']) && t.call(i), c < 2 && ((u = TypeError("The iterator does not provide a '" + o + "' method")), (c = 1)));
                          i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                      } catch (t) {
                        ((i = e), (c = 1), (u = t));
                      } finally {
                        f = 1;
                      }
                    }
                    return { value: t, done: y };
                  };
                })(r, o, i),
                !0
              ),
              u
            );
          }
          var a = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          t = Object.getPrototypeOf;
          var c = [][n]
              ? t(t([][n]()))
              : (_regeneratorDefine2((t = {}), n, function () {
                  return this;
                }),
                t),
            u = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c));
          function f(e) {
            return (Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : ((e.__proto__ = GeneratorFunctionPrototype), _regeneratorDefine2(e, o, 'GeneratorFunction')), (e.prototype = Object.create(u)), e);
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            _regeneratorDefine2(u, 'constructor', GeneratorFunctionPrototype),
            _regeneratorDefine2(GeneratorFunctionPrototype, 'constructor', GeneratorFunction),
            (GeneratorFunction.displayName = 'GeneratorFunction'),
            _regeneratorDefine2(GeneratorFunctionPrototype, o, 'GeneratorFunction'),
            _regeneratorDefine2(u),
            _regeneratorDefine2(u, o, 'Generator'),
            _regeneratorDefine2(u, n, function () {
              return this;
            }),
            _regeneratorDefine2(u, 'toString', function () {
              return '[object Generator]';
            }),
            (_regenerator = function _regenerator() {
              return { w: i, m: f };
            })()
          );
        }
        function _regeneratorDefine2(e, r, n, t) {
          var i = Object.defineProperty;
          try {
            i({}, '', {});
          } catch (e) {
            i = 0;
          }
          ((_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
            function o(r, n) {
              _regeneratorDefine2(e, r, function (e) {
                return this._invoke(r, n, e);
              });
            }
            r ? (i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : (e[r] = n)) : (o('next', 0), o('throw', 1), o('return', 2));
          }),
            _regeneratorDefine2(e, r, n, t));
        }
        function asyncGeneratorStep(n, t, e, r, o, a, c) {
          try {
            var i = n[a](c),
              u = i.value;
          } catch (n) {
            return void e(n);
          }
          i.done ? t(u) : Promise.resolve(u).then(r, o);
        }
        function _asyncToGenerator(n) {
          return function () {
            var t = this,
              e = arguments;
            return new Promise(function (r, o) {
              var a = n.apply(t, e);
              function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'next', n);
              }
              function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, 'throw', n);
              }
              _next(void 0);
            });
          };
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _callSuper(t, o, e) {
          return ((o = _getPrototypeOf(o)), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)));
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
          if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function _inherits(t, e) {
          if ('function' != typeof e && null !== e) throw new TypeError('Super expression must either be null or a function');
          ((t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, 'prototype', { writable: !1 }), e && _setPrototypeOf(t, e));
        }
        function _wrapNativeSuper(t) {
          var r = 'function' == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(t, arguments, _getPrototypeOf(this).constructor);
              }
              return ((Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(Wrapper, t));
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return (r && _setPrototypeOf(p, r.prototype), p);
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
            return !!t;
          })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf('[native code]');
          } catch (n) {
            return 'function' == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return ((t.__proto__ = e), t);
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }
        var ThumbnailDots = /*#__PURE__*/ (function (_HTMLElement) {
          function ThumbnailDots() {
            var _this;
            _classCallCheck(this, ThumbnailDots);
            _this = _callSuper(this, ThumbnailDots);
            _defineProperty(_this, 'productItem', null);
            _defineProperty(_this, 'productItemImageWrapper', null);
            _defineProperty(_this, 'dots', []);
            _defineProperty(_this, 'prevArrow', null);
            _defineProperty(_this, 'nextArrow', null);
            _defineProperty(_this, 'slider', null);
            _defineProperty(_this, 'originalImageSrc', void 0);
            _defineProperty(_this, 'originalImageSrcset', void 0);
            _defineProperty(_this, 'scrollTimeout', null);
            _defineProperty(_this, 'lastScrollTime', 0);
            _defineProperty(_this, 'scrollDebounce', 300);
            // Adjusted debounce time
            _defineProperty(_this, 'wheelEventCount', 0);
            _defineProperty(_this, 'wheelEventThreshold', 3);
            // Reduced threshold for more responsive wheel
            _defineProperty(_this, 'secondaryImage', null);
            _defineProperty(_this, 'preloadedImages', new Map());
            _defineProperty(_this, 'isTransitioning', false);
            _defineProperty(_this, 'touchStartX', 0);
            _defineProperty(_this, 'touchStartY', 0);
            _defineProperty(_this, 'touchEndX', 0);
            _defineProperty(_this, 'touchEndY', 0);
            _defineProperty(_this, 'isSwiping', false);
            _this.initElements = _this.initElements.bind(_this);
            _this.preloadImages = _this.preloadImages.bind(_this);
            _this.addEventListeners = _this.addEventListeners.bind(_this);
            _this.handleWheel = _this.handleWheel.bind(_this);
            _this.changeImage = _this.changeImage.bind(_this);
            _this.switchToImage = _this.switchToImage.bind(_this);
            _this.handleTouchStart = _this.handleTouchStart.bind(_this);
            _this.handleTouchMove = _this.handleTouchMove.bind(_this);
            _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
            _this.resetTransition = _this.resetTransition.bind(_this);
            return _this;
          }
          _inherits(ThumbnailDots, _HTMLElement);
          return _createClass(ThumbnailDots, [
            {
              key: 'connectedCallback',
              value: function connectedCallback() {
                this.initElements();
                this.preloadImages();
                this.addEventListeners();
              },
            },
            {
              key: 'initElements',
              value: function initElements() {
                var _this$productItem, _this$productItem2;
                var isMobile = window.innerWidth < 768;
                this.productItem = this.closest('product-item');
                this.productItemImageWrapper = (_this$productItem = this.productItem) === null || _this$productItem === void 0 ? void 0 : _this$productItem.querySelector('.product-item__image-wrapper');
                this.dots = Array.from(this.querySelectorAll('.media-dot'));
                this.prevArrow = this.querySelector('.nav-arrow--prev');
                this.nextArrow = this.querySelector('.nav-arrow--next');
                this.slider = this.closest('.product-list__inner');
                this.secondaryImage = (_this$productItem2 = this.productItem) === null || _this$productItem2 === void 0 ? void 0 : _this$productItem2.querySelector('.product-item__secondary-image');
                // Store original image source immediately
                if (this.secondaryImage) {
                  // if is mobile secondaryImage is actually product-item__primary-image
                  if (isMobile) {
                    var _this$productItem3;
                    this.secondaryImage = (_this$productItem3 = this.productItem) === null || _this$productItem3 === void 0 ? void 0 : _this$productItem3.querySelector('.product-item__primary-image');
                  }
                  this.originalImageSrc = this.secondaryImage.src;
                  this.originalImageSrcset = this.secondaryImage.srcset;
                  // Set active dot. On mobile the first dot should be active. On desktop the second dot should be active.
                  var activeDot = isMobile ? this.dots[0] : this.dots[1];
                  activeDot.classList.add('active');
                }
              },
            },
            {
              key: 'preloadImages',
              value: (function () {
                var _preloadImages = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee() {
                    var _this2 = this;
                    var preloadPromises;
                    return _regenerator().w(
                      function (_context) {
                        while (1)
                          switch (_context.n) {
                            case 0:
                              preloadPromises = this.dots.map(function (dot) {
                                var mediaUrl = dot.dataset.media;
                                if (!mediaUrl || _this2.preloadedImages.has(mediaUrl)) return Promise.resolve();
                                return new Promise(function (resolve) {
                                  var img = document.createElement('img');
                                  img.src = mediaUrl;
                                  img.onload = function () {
                                    _this2.preloadedImages.set(mediaUrl, img);
                                    resolve();
                                  };
                                  img.onerror = function () {
                                    return resolve();
                                  }; // Continue even if one image fails to load
                                });
                              });
                              _context.n = 1;
                              return Promise.all(preloadPromises);
                            case 1:
                              return _context.a(2);
                          }
                      },
                      _callee,
                      this
                    );
                  })
                );
                function preloadImages() {
                  return _preloadImages.apply(this, arguments);
                }
                return preloadImages;
              })(),
            },
            {
              key: 'addEventListeners',
              value: function addEventListeners() {
                var _this$productItem4,
                  _this$productItemImag,
                  _this$productItemImag2,
                  _this$productItemImag3,
                  _this$prevArrow,
                  _this3 = this,
                  _this$nextArrow;
                (_this$productItem4 = this.productItem) === null ||
                  _this$productItem4 === void 0 ||
                  _this$productItem4.addEventListener('wheel', this.handleWheel.bind(this), {
                    passive: false,
                  });
                (_this$productItemImag = this.productItemImageWrapper) === null || _this$productItemImag === void 0 || _this$productItemImag.addEventListener('touchstart', this.handleTouchStart.bind(this));
                (_this$productItemImag2 = this.productItemImageWrapper) === null ||
                  _this$productItemImag2 === void 0 ||
                  _this$productItemImag2.addEventListener('touchmove', this.handleTouchMove.bind(this), {
                    passive: false,
                  });
                (_this$productItemImag3 = this.productItemImageWrapper) === null || _this$productItemImag3 === void 0 || _this$productItemImag3.addEventListener('touchend', this.handleTouchEnd.bind(this));
                (_this$prevArrow = this.prevArrow) === null ||
                  _this$prevArrow === void 0 ||
                  _this$prevArrow.addEventListener('click', function (event) {
                    event.preventDefault();
                    _this3.changeImage('prev');
                  });
                (_this$nextArrow = this.nextArrow) === null ||
                  _this$nextArrow === void 0 ||
                  _this$nextArrow.addEventListener('click', function (event) {
                    event.preventDefault();
                    _this3.changeImage('next');
                  });
              },
            },
            {
              key: 'handleWheel',
              value: function handleWheel(event) {
                // Only handle horizontal wheel events
                if (Math.abs(event.deltaX) < Math.abs(event.deltaY)) return;
                event.preventDefault();
                this.wheelEventCount += 1;
                if (this.wheelEventCount < this.wheelEventThreshold) return;
                var now = Date.now();
                if (now - this.lastScrollTime < this.scrollDebounce) {
                  this.wheelEventCount = 0;
                  return;
                }
                if (!this.secondaryImage || this.isTransitioning) return;
                var direction = event.deltaX > 0 ? 'next' : 'prev';
                this.changeImage(direction);
                this.lastScrollTime = now;
                this.wheelEventCount = 0;
              },
            },
            {
              key: 'changeImage',
              value: function changeImage(direction) {
                if (!this.dots.length) return;
                var currentIndex = this.dots.findIndex(function (dot) {
                  return dot.classList.contains('active');
                });
                if (currentIndex === -1) return;
                var totalDots = this.dots.length;
                var nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
                // Wrap around
                if (nextIndex >= totalDots) nextIndex = 0;
                else if (nextIndex < 0) nextIndex = totalDots - 1;
                var nextDot = this.dots[nextIndex];
                var newImageSrc = nextDot.dataset.media;
                if (!newImageSrc) return;
                this.switchToImage(newImageSrc, nextDot);
              },
            },
            {
              key: 'switchToImage',
              value: (function () {
                var _switchToImage = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee2(imageSrc, dot) {
                    var _this$slider,
                      _this4 = this;
                    var preloaded;
                    return _regenerator().w(
                      function (_context2) {
                        while (1)
                          switch ((_context2.p = _context2.n)) {
                            case 0:
                              if (!(!this.secondaryImage || this.isTransitioning)) {
                                _context2.n = 1;
                                break;
                              }
                              return _context2.a(2);
                            case 1:
                              this.isTransitioning = true;
                              // Add loading class for visual feedback
                              this.secondaryImage.classList.add('loading');
                              // Add no-transition class to slider
                              (_this$slider = this.slider) === null || _this$slider === void 0 || _this$slider.classList.add('no-transition');
                              // Update active dot immediately for visual feedback
                              this.dots.forEach(function (d) {
                                return d.classList.remove('active');
                              });
                              dot.classList.add('active');
                              _context2.p = 2;
                              // Check if image is preloaded
                              preloaded = this.preloadedImages.get(imageSrc);
                              if (!(preloaded && preloaded.complete)) {
                                _context2.n = 3;
                                break;
                              }
                              // Use preloaded image
                              this.secondaryImage.src = imageSrc;
                              this.secondaryImage.srcset = imageSrc;
                              _context2.n = 4;
                              break;
                            case 3:
                              _context2.n = 4;
                              return new Promise(function (resolve) {
                                _this4.secondaryImage.onload = function () {
                                  return resolve();
                                };
                                _this4.secondaryImage.onerror = function () {
                                  return resolve();
                                };
                                _this4.secondaryImage.src = imageSrc;
                                _this4.secondaryImage.srcset = imageSrc;
                              });
                            case 4:
                              _context2.p = 4;
                              // Remove loading state
                              this.secondaryImage.classList.remove('loading');
                              this.resetTransition();
                              this.isTransitioning = false;
                              return _context2.f(4);
                            case 5:
                              return _context2.a(2);
                          }
                      },
                      _callee2,
                      this,
                      [[2, , 4, 5]]
                    );
                  })
                );
                function switchToImage(_x, _x2) {
                  return _switchToImage.apply(this, arguments);
                }
                return switchToImage;
              })(),
            },
            {
              key: 'handleTouchStart',
              value: function handleTouchStart(event) {
                this.touchStartX = event.touches[0].clientX;
                this.touchStartY = event.touches[0].clientY;
                this.isSwiping = false;
              },
            },
            {
              key: 'handleTouchMove',
              value: function handleTouchMove(event) {
                if (event.touches.length > 1) return; // Ignore multi-touch
                this.touchEndX = event.touches[0].clientX;
                this.touchEndY = event.touches[0].clientY;
                // Detect if the user is swiping horizontally more than vertically
                var deltaX = this.touchEndX - this.touchStartX;
                var deltaY = this.touchEndY - this.touchStartY;
                if (Math.abs(deltaX) > Math.abs(deltaY)) {
                  this.isSwiping = true;
                  event.preventDefault(); // Prevent vertical scrolling
                }
              },
            },
            {
              key: 'handleTouchEnd',
              value: function handleTouchEnd() {
                if (!this.isSwiping) return;
                var deltaX = this.touchEndX - this.touchStartX;
                if (Math.abs(deltaX) > 30) {
                  // Adjust threshold as needed
                  var direction = deltaX < 0 ? 'next' : 'prev';
                  this.changeImage(direction);
                }
              },
            },
            {
              key: 'resetTransition',
              value: function resetTransition() {
                var _this5 = this;
                if (this.scrollTimeout) {
                  clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = window.setTimeout(function () {
                  var _this5$slider;
                  (_this5$slider = _this5.slider) === null || _this5$slider === void 0 || _this5$slider.classList.remove('no-transition');
                  _this5.scrollTimeout = null;
                }, 150); // Slightly longer timeout for smoother transition
              },
            },
            {
              key: 'disconnectedCallback',
              value: function disconnectedCallback() {
                var _this$productItem5;
                (_this$productItem5 = this.productItem) === null || _this$productItem5 === void 0 || _this$productItem5.removeEventListener('wheel', this.handleWheel);
                if (this.scrollTimeout) {
                  clearTimeout(this.scrollTimeout);
                }
              },
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ './resources/scripts/utils/CookieMethods.ts':
      /*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getCookie: () => /* binding */ getCookie,
          /* harmony export */ setCookie: () => /* binding */ setCookie,
          /* harmony export */
        });
        function getCookie(name) {
          var match = document.cookie.match(new RegExp('(?:^|; )'.concat(name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1'), '=([^;]*)')));
          return match ? decodeURIComponent(match[1]) : null;
        }
        function setCookie(name, value, minutes) {
          var expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
          document.cookie = ''.concat(name, '=').concat(encodeURIComponent(value), '; expires=').concat(expires, '; path=/');
        }

        /***/
      },

    /***/ './resources/scripts/utils/Logger.ts':
      /*!*******************************************!*\
  !*** ./resources/scripts/utils/Logger.ts ***!
  \*******************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        /**
         * Structured Logger Utility
         * Logs structured objects with timestamps, levels, and metadata
         *
         * @example
         * import log from '@utils/Logger';
         *
         * log.info('User logged in', { userId: 123 });
         * log.success('Payment processed', { amount: 99.99 });
         * log.warn('Cart is empty');
         * log.error('API request failed', { endpoint: '/api/cart' });
         */
        var styles = {
          INFO: 'color: #3B82F6; font-weight: bold;',
          SUCCESS: 'color: #10B981; font-weight: bold;',
          WARN: 'color: #F59E0B; font-weight: bold;',
          ERROR: 'color: #EF4444; font-weight: bold;',
        };
        var createLogEntry = function createLogEntry(level, message, additionalData) {
          var includeStack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          var timestamp = new Date().toISOString();
          // Handle different message types
          var logMessage;
          var logData = additionalData;
          if (typeof message === 'string') {
            logMessage = message;
          } else if (_typeof(message) === 'object' && message !== null) {
            logMessage = 'Object logged';
            logData = message;
          } else {
            logMessage = String(message);
          }
          var entry = {
            timestamp: timestamp,
            level: level,
            message: logMessage,
          };
          if (logData !== undefined) {
            entry.data = logData;
          }
          // Add stack trace for errors or when explicitly requested
          if (includeStack) {
            var _Error = new Error(),
              stack = _Error.stack;
            if (stack) {
              // Remove the first 3 lines (Error message and logger internals)
              entry.stack = stack.split('\n').slice(3).join('\n');
            }
          }
          // Add context information
          if (typeof window !== 'undefined') {
            entry.context = {
              url: window.location.href,
              userAgent: navigator.userAgent,
              viewport: {
                width: window.innerWidth,
                height: window.innerHeight,
              },
            };
          }
          return entry;
        };
        var logWithStyle = function logWithStyle(consoleMethod, level, entry) {
          console[consoleMethod]('%c['.concat(level, ']'), styles[level], entry);
        };
        var logger = {
          info: function info(message, data) {
            var entry = createLogEntry('INFO', message, data);
            logWithStyle('log', 'INFO', entry);
          },
          success: function success(message, data) {
            var entry = createLogEntry('SUCCESS', message, data);
            logWithStyle('log', 'SUCCESS', entry);
          },
          warn: function warn(message, data) {
            var entry = createLogEntry('WARN', message, data, true);
            logWithStyle('warn', 'WARN', entry);
          },
          error: function error(message, data) {
            var entry = createLogEntry('ERROR', message, data, true);
            logWithStyle('error', 'ERROR', entry);
          },
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = logger;

        /***/
      },

    /***/ './resources/scripts/utils/Storage.ts':
      /*!********************************************!*\
  !*** ./resources/scripts/utils/Storage.ts ***!
  \********************************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ NamespacedStorage: () => /* binding */ NamespacedStorage,
          /* harmony export */ StorageHelper: () => /* binding */ StorageHelper,
          /* harmony export */ local: () => /* binding */ local,
          /* harmony export */ session: () => /* binding */ session,
          /* harmony export */
        });
        /* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Logger */ './resources/scripts/utils/Logger.ts');
        function _typeof(o) {
          '@babel/helpers - typeof';
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _readOnlyError(r) {
          throw new TypeError('"' + r + '" is read-only');
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            ((o.enumerable = o.enumerable || !1), (o.configurable = !0), 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o));
          }
        }
        function _createClass(e, r, t) {
          return (r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e);
        }
        function _defineProperty(e, r, t) {
          return ((r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : (e[r] = t), e);
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, 'string');
          return 'symbol' == _typeof(i) ? i : i + '';
        }
        function _toPrimitive(t, r) {
          if ('object' != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || 'default');
            if ('object' != _typeof(i)) return i;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === r ? String : Number)(t);
        }
        /* eslint-disable @typescript-eslint/no-use-before-define */
        /* eslint-disable no-plusplus */
        /* eslint-disable max-classes-per-file */
        /**
         * Type-safe LocalStorage and SessionStorage Utility
         * Handles JSON parsing, expiration, and error handling
         *
         * @example
         * import { local, session } from '@utils/Storage';
         *
         * // Basic usage LocalStorage
         * local.set('user', { id: 123, name: 'John' });
         * const user = local.get('user'); // Returns parsed object or null
         *
         * // With expiration (in minutes)
         * local.set('token', 'abc123', 60); // Expires in 60 minutes
         *
         * // Basic usage SessionStorage
         * session.set('sessionId', 'xyz789');
         * const sessionId = session.get('sessionId'); // Returns 'xyz789' or null
         *
         * // Advanced usage with namespaces
         * const cartStorage = local.namespace('cart');
         * cartStorage.set('items', [{ id: 1, qty: 2 }]);
         * const items = cartStorage.get('items'); // Returns array or null
         */

        var StorageHelper = /*#__PURE__*/ (function () {
          function StorageHelper(type) {
            _classCallCheck(this, StorageHelper);
            _defineProperty(this, 'storage', null);
            _defineProperty(this, 'type', void 0);
            _defineProperty(this, 'isAvailable', false);
            this.type = type;
            this.checkAvailability();
          }
          /**
           * Check if storage is available (handles private browsing, etc.)
           */
          return _createClass(StorageHelper, [
            {
              key: 'checkAvailability',
              value: function checkAvailability() {
                try {
                  var storage = window[this.type];
                  var testKey = '__storage_test__';
                  storage.setItem(testKey, 'test');
                  storage.removeItem(testKey);
                  this.storage = storage;
                  this.isAvailable = true;
                } catch (e) {
                  this.isAvailable = false;
                  _Logger__WEBPACK_IMPORTED_MODULE_0__['default'].warn(''.concat(this.type, ' is not available'), {
                    error: e,
                  });
                }
              },
              /**
               * Set an item in storage
               */
            },
            {
              key: 'set',
              value: function set(key, value, expiresInMinutes) {
                if (!this.isAvailable || !this.storage) return false;
                try {
                  var item = {
                    value: value,
                  };
                  if (expiresInMinutes) {
                    item.expires = Date.now() + expiresInMinutes * 60 * 1000;
                  }
                  this.storage.setItem(key, JSON.stringify(item));
                  return true;
                } catch (e) {
                  _Logger__WEBPACK_IMPORTED_MODULE_0__['default'].error('Failed to set storage item', {
                    key: key,
                    error: e,
                  });
                  return false;
                }
              },
              /**
               * Get an item from storage
               */
            },
            {
              key: 'get',
              value: function get(key) {
                if (!this.isAvailable || !this.storage) return null;
                try {
                  var raw = this.storage.getItem(key);
                  if (!raw) return null;
                  var item = JSON.parse(raw);
                  // Check expiration
                  if (item.expires && Date.now() > item.expires) {
                    this.remove(key);
                    return null;
                  }
                  return item.value;
                } catch (e) {
                  _Logger__WEBPACK_IMPORTED_MODULE_0__['default'].error('Failed to get storage item', {
                    key: key,
                    error: e,
                  });
                  return null;
                }
              },
              /**
               * Remove an item from storage
               */
            },
            {
              key: 'remove',
              value: function remove(key) {
                if (!this.isAvailable || !this.storage) return false;
                try {
                  this.storage.removeItem(key);
                  return true;
                } catch (e) {
                  _Logger__WEBPACK_IMPORTED_MODULE_0__['default'].error('Failed to remove storage item', {
                    key: key,
                    error: e,
                  });
                  return false;
                }
              },
              /**
               * Clear all items from storage
               */
            },
            {
              key: 'clear',
              value: function clear() {
                if (!this.isAvailable || !this.storage) return false;
                try {
                  this.storage.clear();
                  return true;
                } catch (e) {
                  _Logger__WEBPACK_IMPORTED_MODULE_0__['default'].error('Failed to clear storage', {
                    error: e,
                  });
                  return false;
                }
              },
              /**
               * Check if a key exists in storage
               */
            },
            {
              key: 'has',
              value: function has(key) {
                if (!this.isAvailable || !this.storage) return false;
                return this.storage.getItem(key) !== null;
              },
              /**
               * Get all keys in storage
               */
            },
            {
              key: 'keys',
              value: function keys() {
                if (!this.isAvailable || !this.storage) return [];
                var keys = [];
                for (var i = 0; i < this.storage.length; i++) {
                  var key = this.storage.key(i);
                  if (key) keys.push(key);
                }
                return keys;
              },
              /**
               * Get storage size in bytes (approximate)
               */
            },
            {
              key: 'size',
              value: function size() {
                if (!this.isAvailable || !this.storage) return 0;
                var total = 0;
                for (var i = 0; i < this.storage.length; i++) {
                  var key = this.storage.key(i);
                  if (key) {
                    var value = this.storage.getItem(key);
                    if (value) {
                      total += key.length + value.length;
                    }
                  }
                }
                return total;
              },
              /**
               * Create a namespaced storage helper
               * Prefixes all keys with the namespace
               */
            },
            {
              key: 'namespace',
              value: function namespace(prefix) {
                return new NamespacedStorage(this, prefix);
              },
              /**
               * Check if storage is available
               */
            },
            {
              key: 'available',
              get: function get() {
                return this.isAvailable;
              },
            },
          ]);
        })();
        /**
         * Namespaced storage helper
         * Automatically prefixes all keys with a namespace
         */
        var NamespacedStorage = /*#__PURE__*/ (function () {
          function NamespacedStorage(storage, prefix) {
            _classCallCheck(this, NamespacedStorage);
            _defineProperty(this, 'storage', void 0);
            _defineProperty(this, 'prefix', void 0);
            this.storage = storage;
            this.prefix = prefix;
          }
          return _createClass(NamespacedStorage, [
            {
              key: 'getKey',
              value: function getKey(key) {
                return ''.concat(this.prefix, ':').concat(key);
              },
            },
            {
              key: 'set',
              value: function set(key, value, expiresInMinutes) {
                return this.storage.set(this.getKey(key), value, expiresInMinutes);
              },
            },
            {
              key: 'get',
              value: function get(key) {
                return this.storage.get(this.getKey(key));
              },
            },
            {
              key: 'remove',
              value: function remove(key) {
                return this.storage.remove(this.getKey(key));
              },
            },
            {
              key: 'has',
              value: function has(key) {
                return this.storage.has(this.getKey(key));
              },
              /**
               * Clear all items in this namespace
               */
            },
            {
              key: 'clear',
              value: function clear() {
                var _this = this;
                var keys = this.storage.keys().filter(function (key) {
                  return key.startsWith(''.concat(_this.prefix, ':'));
                });
                var success = true;
                keys.forEach(function (key) {
                  if (!_this.storage.remove(key)) {
                    success = false;
                  }
                });
                return success;
              },
              /**
               * Get all keys in this namespace (without prefix)
               */
            },
            {
              key: 'keys',
              value: function keys() {
                var _this2 = this;
                var prefixLength = this.prefix.length + 1;
                return this.storage
                  .keys()
                  .filter(function (key) {
                    return key.startsWith(''.concat(_this2.prefix, ':'));
                  })
                  .map(function (key) {
                    return key.substring(prefixLength);
                  });
              },
            },
          ]);
        })(); // Export singleton instances
        var local = new StorageHelper('localStorage');
        var session = new StorageHelper('sessionStorage');
        // Export classes for advanced usage

        /***/
      },

    /***/ './resources/styles/app.css':
      /*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
      /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        // extracted by mini-css-extract-plugin

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = __webpack_modules__;
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/chunk loaded */
  /******/ (() => {
    /******/ var deferred = [];
    /******/ __webpack_require__.O = (result, chunkIds, fn, priority) => {
      /******/ if (chunkIds) {
        /******/ priority = priority || 0;
        /******/ for (var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
        /******/ deferred[i] = [chunkIds, fn, priority];
        /******/ return;
        /******/
      }
      /******/ var notFulfilled = Infinity;
      /******/ for (var i = 0; i < deferred.length; i++) {
        /******/ var [chunkIds, fn, priority] = deferred[i];
        /******/ var fulfilled = true;
        /******/ for (var j = 0; j < chunkIds.length; j++) {
          /******/ if ((priority & (1 === 0) || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => __webpack_require__.O[key](chunkIds[j]))) {
            /******/ chunkIds.splice(j--, 1);
            /******/
          } else {
            /******/ fulfilled = false;
            /******/ if (priority < notFulfilled) notFulfilled = priority;
            /******/
          }
          /******/
        }
        /******/ if (fulfilled) {
          /******/ deferred.splice(i--, 1);
          /******/ var r = fn();
          /******/ if (r !== undefined) result = r;
          /******/
        }
        /******/
      }
      /******/ return result;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          /******/ Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
        /******/
      }
      /******/ Object.defineProperty(exports, '__esModule', { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/jsonp chunk loading */
  /******/ (() => {
    /******/ // no baseURI
    /******/
    /******/ // object to store loaded and loading chunks
    /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
    /******/ // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
    /******/ var installedChunks = {
      /******/ '/src/assets/app': 0,
      /******/ 'src/assets/app': 0,
      /******/
    };
    /******/
    /******/ // no chunk on demand loading
    /******/
    /******/ // no prefetching
    /******/
    /******/ // no preloaded
    /******/
    /******/ // no HMR
    /******/
    /******/ // no HMR manifest
    /******/
    /******/ __webpack_require__.O.j = (chunkId) => installedChunks[chunkId] === 0;
    /******/
    /******/ // install a JSONP callback for chunk loading
    /******/ var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
      /******/ var [chunkIds, moreModules, runtime] = data;
      /******/ // add "moreModules" to the modules object,
      /******/ // then flag all "chunkIds" as loaded and fire callback
      /******/ var moduleId,
        chunkId,
        i = 0;
      /******/ if (chunkIds.some((id) => installedChunks[id] !== 0)) {
        /******/ for (moduleId in moreModules) {
          /******/ if (__webpack_require__.o(moreModules, moduleId)) {
            /******/ __webpack_require__.m[moduleId] = moreModules[moduleId];
            /******/
          }
          /******/
        }
        /******/ if (runtime) var result = runtime(__webpack_require__);
        /******/
      }
      /******/ if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
      /******/ for (; i < chunkIds.length; i++) {
        /******/ chunkId = chunkIds[i];
        /******/ if (__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
          /******/ installedChunks[chunkId][0]();
          /******/
        }
        /******/ installedChunks[chunkId] = 0;
        /******/
      }
      /******/ return __webpack_require__.O(result);
      /******/
    };
    /******/
    /******/ var chunkLoadingGlobal = (self['webpackChunkfinicc_com'] = self['webpackChunkfinicc_com'] || []);
    /******/ chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
    /******/ chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
    /******/
  })();
  /******/
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module depends on other loaded chunks and execution need to be delayed
  /******/ __webpack_require__.O(undefined, ['src/assets/app'], () => __webpack_require__('./resources/app.ts'));
  /******/ var __webpack_exports__ = __webpack_require__.O(undefined, ['src/assets/app'], () => __webpack_require__('./resources/styles/app.css'));
  /******/ __webpack_exports__ = __webpack_require__.O(__webpack_exports__);
  /******/
  /******/
})();
